import { render, staticRenderFns } from "./MQSeriesConfigurationForm.vue?vue&type=template&id=56b27db4&"
import script from "./MQSeriesConfigurationForm.vue?vue&type=script&lang=js&"
export * from "./MQSeriesConfigurationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports